import { toast } from "sonner";
import { BaseDialog } from "@/lib/Components/Dialog/BaseDialog";
import { GenericForm } from "@/lib/Components/Form/Forms/GenericForm";
import { TextInput } from "@/lib/Components/Form/Inputs/TextInput";
import { DialogSubmitButton } from "@/lib/Components/Dialog/Components/DialogSubmitButton";
import { useDialogState } from "@/lib/Components/Dialog/Hooks/useDialogState";
import { useGqlMutation } from "@/lib/GraphQLCodegen/fetcher";
import { updateMediaMutation } from "@/app/Media/GraphQL/mediaMutations";

export function BlogHeroImageAltDialog({
  mediaId,
  alt,
  imageUrl,
}: {
  mediaId: string;
  alt: string | null;
  imageUrl: string;
}) {
  const { close } = useDialogState();
  const { mutateAsync } = useGqlMutation(updateMediaMutation);

  return (
    <BaseDialog
      title="Hero image alt text"
      subtitle="Describe what's in the photo for search engines and screen readers. Without it, the post title is used."
      size="xl"
    >
      <img
        src={imageUrl}
        alt=""
        className="mb-6 max-h-56 w-auto rounded-md border border-zinc-200 object-cover"
      />
      <GenericForm<{ alt: string }>
        initialValues={{ alt: alt ?? "" }}
        onSubmit={async (values) => {
          await mutateAsync({
            id: mediaId,
            input: { alt: values.alt.trim() || null },
          });
          toast.success("Alt text saved");
          close();
        }}
      >
        <TextInput
          autoFocus
          name="alt"
          label="Alt text"
          className="col-span-full"
          description="e.g. “Glenelg jetty and Ferris wheel in Adelaide”"
        />
        <DialogSubmitButton text="Save alt text" />
      </GenericForm>
    </BaseDialog>
  );
}
